module.exports = __webpack_public_path__ + "d0cb2a5d2baddb768cd5aceb7d114de9.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-jeff.png
// module id = 658
// module chunks = 0